module.exports = __webpack_public_path__ + "media/images/shopping-cart-c91d5a02db0cf26d0dffd6f8c3d5c6c0.png";